import { logWrapper } from '../../utils';

export default {
  dashboardController: [
    'runtimeConstant',
    '$scope',
    '$filter',
    'authService',
    'dashboardService',
    function (runtimeConstant, $scope, $filter, authService, dashboardService) {
      'use strict';

      function numberWithDot(x) {
        var parts = x.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return parts.join('.');
      }

      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      function getColor() {
        var color = [
          getRandomInt(0, 255),
          getRandomInt(0, 255),
          getRandomInt(0, 255),
        ];
        var alpha = 0.9;
        color = color.slice(0, 3);
        var background = 'rgb(' + color.join(',') + ')';

        var rgba = [color[0], color[1] + 10, color[2] + 10];
        var point = 'rgba(' + rgba.concat(alpha).join(',') + ')';
        return {
          backgroundColor: background,
          pointBackgroundColor: point,
        };
      }

      function descriptionDocumentsNumber() {
        if (!$scope.documentsData || $scope.documentsData[0].length === 1) {
          return '';
        }

        var length = $scope.documentsData[0].length;
        if (length === 0) {
          return 12;
        }

        return length;
      }

      function initDocuments() {
        $scope.documentsLabel = [];
        $scope.documentsData = null;
        $scope.documentsSeries = [$filter('translate')('DOCUMENTS SENT')];

        dashboardService.getSentDocumentsMonth().then(function (dictionary) {
          $scope.documentsData = [[]];
          for (var key in dictionary) {
            if (dictionary.hasOwnProperty(key)) {
              $scope.documentsLabel.push(new Date(key));
              $scope.documentsData[0].push(dictionary[key]);
            }
          }
        });

        $scope.documentsColors = [
          {
            backgroundColor: 'rgba(159,204,0,0.2)',
            borderColor: 'rgba(159,204,0,1)',
            pointBackgroundColor: 'rgba(159,204,0,1)',
            pointHoverBackgroundColor: 'rgba(159,204,0,0.8)',
            pointBorderColor: '#fff',
            pointHoverBorderColor: 'rgba(159,204,0,1)',
          },
        ];

        $scope.documentsOptions = {
          maintainAspectRatio: false,
          responsive: true,
          title: {
            text: $filter('translate')('SENT'),
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var value = data.datasets[0].data[tooltipItem.index];
                var label = ' ' + data.datasets[0].label;
                return label + ': ' + numberWithDot(value);
              },
            },
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  callback: function (value) {
                    var splitted = value.split('/');
                    var m = splitted[0];
                    var month = $filter('translate')(m);
                    return month + '/' + splitted[1];
                  },
                },
                type: 'time',
                time: {
                  unit: 'month',
                  displayFormats: {
                    month: 'MMM/YY',
                  },
                  round: 'month',
                  tooltipFormat: 'MM/YYYY',
                },
                scaleLabel: {
                  display: true,
                  labelString: $filter('translate')('MONTHS'),
                },
              },
            ],
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: $filter('translate')('NUMBER OF DOCUMENTS'),
                },
              },
            ],
          },
        };
      }

      function initUsedGbs() {
        $scope.usedGbsColors = [
          {
            backgroundColor: 'rgb(255, 51, 51)',
            borderColor: 'rgb(255, 80, 80)',
            pointBackgroundColor: 'rgba(255, 60, 60, 0.9)',
          },
          {
            backgroundColor: 'rgb(244, 155, 66)',
            borderColor: 'rgb(255, 80, 80)',
            pointBackgroundColor: 'rgba(244, 165, 76, 0.9)',
          },
          {
            backgroundColor: 'rgb(54, 162, 235)',
            borderColor: 'rgb(255, 80, 80)',
            pointBackgroundColor: 'rgba(54, 172, 245, 0.9)',
          },
        ];

        $scope.usedGbsOptions = {
          responsive: true,
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var value = data.datasets[0].data[tooltipItem.index];
                var label = ' ' + data.labels[tooltipItem.index];
                return label + ' ' + value + ' GBs';
              },
            },
          },
        };

        $scope.usedGbsData = null;

        dashboardService.getUsedGbs().then(function (obj) {
          var usedCompany = obj.usedGbsCompany ? obj.usedGbsCompany : 0;
          var usedOtherCompanies = obj.usedGbsOtherCompanies
            ? obj.usedGbsOtherCompanies
            : 0;

          var lb =
            usedOtherCompanies > 0
              ? authService.getLoggedCompany().Company.Name
              : $filter('translate')('USED');
          $scope.usedGbsLabels = [
            lb,
            $filter('translate')('OTHER COMPANIES CONTRACT'),
            $filter('translate')('ENABLED'),
          ];

          $scope.usedGbsData = [];
          $scope.usedGbsData.push(usedCompany);
          $scope.usedGbsData.push(usedOtherCompanies);
          $scope.usedGbsData.push(obj.avaliable);
        });
      }

      function initRepositoryGbs() {
        $scope.repositoryGbsOptions = {
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true,
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var value = data.datasets[0].data[tooltipItem.index];
                var label = ' ' + data.labels[tooltipItem.index];

                if (value === 0.0001) {
                  return label;
                }
                return label + ': ' + value + ' GBs';
              },
            },
          },
        };

        $scope.repositoryGbsData = null;
        $scope.repositoryGbsLabels = [];

        dashboardService.getRepositoryGbs().then(function (dictionary) {
          $scope.repositoryGbsColors = [];
          $scope.repositoryGbsData = [];
          for (var key in dictionary) {
            if (dictionary.hasOwnProperty(key)) {
              $scope.repositoryGbsLabels.push(key);
              $scope.repositoryGbsData.push(dictionary[key]);
              $scope.repositoryGbsColors.push(getColor());
            }
          }
        });
      }

      function initCountDocuments() {
        $scope.countDocuments = null;
        dashboardService.countDocuments().then(function (count) {
          $scope.countDocuments = numberWithDot(count);
        });
      }

      function initCountFolders() {
        $scope.countFolders = null;
        dashboardService.countFolders().then(function (count) {
          count = numberWithDot(count);
          $scope.countFolders = count;
        });
      }

      function initCountRegistredUsers() {
        $scope.countRegistredUsers = undefined;
        dashboardService.countRegistredUsers().then(function (users) {
          $scope.countRegistredUsers = jQuery.isEmptyObject(users)
            ? 0
            : users.countUsers;
          if (users.limit > 0) {
            $scope.countRegistredUsers += '/' + users.limit;
          }
        });
      }

      function initCountIndexedPages() {
        $scope.countIndexedPages = null;
        dashboardService.countIndexedPages().then(function (pages) {
          $scope.countIndexedPages = numberWithDot(pages);
        });
      }

      function initIndexedPagesByUser() {
        $scope.indexedPagesByUserColors = [];
        $scope.indexedPagesByUserData = null;

        $scope.indexedPagesByUserOptions = {
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var value = data.datasets[0].data[tooltipItem.index];
                var label = ' ' + data.labels[tooltipItem.index];
                return label + ': ' + numberWithDot(value);
              },
            },
          },
        };

        dashboardService.indexedPagesByUser().then(function (dictionary) {
          $scope.indexedPagesByUserData = [];
          $scope.indexedPagesByUserLabels = [];
          for (var key in dictionary) {
            if (dictionary.hasOwnProperty(key)) {
              $scope.indexedPagesByUserLabels.push(key);
              $scope.indexedPagesByUserData.push(dictionary[key]);
              $scope.indexedPagesByUserColors.push(getColor());
            }
          }
        });
      }

      function initMostActiveUsers() {
        var ctx = document.getElementById('idMostActiveUsers').getContext('2d');
        $scope.circleChart = null;

        dashboardService.mostActiveUsers().then(function (users) {
          $scope.mostActiveUsersData = [];
          $scope.mostActiveUsersLabels = [];
          for (var key in users) {
            if (users.hasOwnProperty(key)) {
              $scope.mostActiveUsersLabels.push(key);
              $scope.mostActiveUsersData.push(users[key]);
            }
          }

          var config = createConfig();
          /*jshint -W117 */
          $scope.circleChart = new Chart(ctx, config);
          /*jshint +W117 */
        });

        function createConfig() {
          return {
            type: 'line',
            data: {
              labels: $scope.mostActiveUsersLabels,
              datasets: [
                {
                  backgroundColor: 'rgb(255, 99, 132)',
                  borderColor: 'rgb(255, 99, 132)',
                  data: $scope.mostActiveUsersData,
                  fill: false,
                  pointRadius: 10,
                  pointHoverRadius: 15,
                  showLine: false, // no line shown
                },
              ],
            },
            options: {
              responsive: true,
              legend: {
                display: false,
              },
              elements: {
                point: {
                  pointStyle: 'circle',
                },
              },
              scales: {
                yAxes: [
                  {
                    scaleLabel: {
                      display: true,
                      labelString: 'Nº de acessos',
                    },
                  },
                ],
              },
            },
          };
        }
      }

      function run() {
        try {
          $scope.descriptionDocumentsNumber = logWrapper(
            descriptionDocumentsNumber,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initDocuments = logWrapper(
            initDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initUsedGbs = logWrapper(
            initUsedGbs,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initRepositoryGbs = logWrapper(
            initRepositoryGbs,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initCountDocuments = logWrapper(
            initCountDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initCountFolders = logWrapper(
            initCountFolders,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initCountRegistredUsers = logWrapper(
            initCountRegistredUsers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initCountIndexedPages = logWrapper(
            initCountIndexedPages,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initIndexedPagesByUser = logWrapper(
            initIndexedPagesByUser,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initMostActiveUsers = logWrapper(
            initMostActiveUsers,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.initMostActiveUsers();
          $scope.initIndexedPagesByUser();
          $scope.initCountIndexedPages();
          $scope.initCountRegistredUsers();
          $scope.initCountFolders();
          $scope.initRepositoryGbs();
          $scope.initDocuments();
          $scope.initUsedGbs();
          $scope.initCountDocuments();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
